import {NameValueDTO} from '../../common/models/NameValueDTO';
import {BaseDTO} from '../../common/models/BaseDTO';

export class RefillDTO extends BaseDTO {
  refillId: number;
  name: string;
  refillValue: number;
  refillMeasurement: NameValueDTO;
}
